import { render, staticRenderFns } from "./threeLabel.vue?vue&type=template&id=38c8f5fa"
import script from "./threeLabel.vue?vue&type=script&lang=js"
export * from "./threeLabel.vue?vue&type=script&lang=js"
import style0 from "./threeLabel.vue?vue&type=style&index=0&id=38c8f5fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports